<template>
	<div class="realtime">
		<border :showState="false" width="31%" siteName="企业信息" iconfont="icon-hangyefenbu" height="675"
			background="transparent">
      <div class="company-info">
        <div class="company-name">名称：{{ companyInfo.companyName || '无' }}</div>
        <div class="company-name">组织机构代码：{{ companyInfo.companyCode || '无' }}</div>
        <div class="company-name">统一社会信用代码：{{ companyInfo.creditCode || '无' }}</div>
        <div class="company-name">企业类别：{{ handleDictName('typeArr', companyInfo.type) || '无' }}</div>
        <div class="company-name">管理属性：{{ handleDictName('attributeArr', companyInfo.managementAttribute) || '无' }}</div>
        <div class="company-name">企业规模：{{ handleDictName('scaleArr', companyInfo.companyScale) || '无' }}</div>
        <div class="company-name">是否重点污染源：{{ handleDictName('yesNoStatusArr', companyInfo.keyPollutionSource) || '无' }}</div>
        <div class="company-name">行政区域：{{ companyInfo.administrativeDivision || '无' }}</div>
        <div class="company-name">所属行业：{{ companyInfo.industry || '无' }}</div>
        <div class="company-name">法人代表：{{ companyInfo.legalPerson || '无' }}</div>
        <div class="company-name">联系人：{{ companyInfo.contact || '无' }}</div>
        <div class="company-name">联系人电话：{{ companyInfo.contactTel || '无' }}</div>
        <div class="company-name">经营范围：{{ companyInfo.businessScope || '无' }}</div>
        <div class="company-name">详细地址：{{ companyInfo.address || '无' }}</div>
          </div>
		</border>
		<div style="display: flex; flex-direction: column; margin-left: 20px;width:67%;">
			<div style="display: flex">
				<border siteName="实时排放" iconfont="icon-biaozhunhuadabiao" :showState="false" width="50%" height="322"
					background="transparent">
          <file-table height="250px" :top="flowData?'5px':'33px'" type='5' :dateList="dateList"
			 minSum="6"></file-table>
					<!-- <dial ref="dials" v-if="showDial" height="480px" width="113%" left="-32px" top="-70px"></dial> -->
				</border>
				<border siteName="站点警报" iconfont="icon-yujing1" left="20" :showState="false" width="50%" height="322"
					background="transparent">
					<warn radioTop='21px' :radioStatu='radioStatu' :current='defaultValues'
						:defaultValue='defaultValues' :siteWarnList="waterWarnList" siteType="3" height="295px"
						top="67px" @changetadios='changetadios' minSum="5"></warn>
				</border>
			</div>
			<div style="display: flex">
				<border siteName="排放趋势" iconfont="icon-wuranyuanguanli" :showState="false" width="50%" height="322"
					background="transparent">
					<div class="radios" v-if="showRadio"
						style="width: 100%;display: flex;justify-content: center;padding-top: 20px;">
						<a-radio-group :defaultValue="defaultValue" @change="changeRadio">
							<a-radio :value="1">24H</a-radio>
							<a-radio :value="2">7天</a-radio>
							<a-radio :value="3">30天</a-radio>
						</a-radio-group>
					</div>
					<analysis v-if="showAnalysis" ref="pollution" cacheKey="waste_water_legend_selected" top="10px" width="100%" height="310px"></analysis>
				</border>
				<border siteName="排放日历" iconfont="icon-icon-test1" left="20" :showState="false" width="50%" height="322"
					background="transparent">
					<!-- <div class="border-detail iconfont icon-bingtu" title="查看饼图" @click="ontoSelect"></div> -->
					<div class="toast" v-if="showToast">{{ toastText }}</div>
					<!-- <div class="border-right">
            <div
              class="map-tag-cir"
              v-for="(item, index) in stand"
              :style="'background-color:' + [item.data.color]"
              :title="item.title" 
              :key="index"
            >
              {{ item.data.title }}
            </div>
          </div> -->
					<div>
						<month-select @change="monthChange" top='30px'></month-select>
						<calendar @content="ontoGet" ref="calendar" width="80%" height="270px" top="40px" left="40px">
						</calendar>
					</div>
					<!-- <div class="popout" v-if="showDetail">
            <div class="iconfont icon-dacha" @click="showDetail = false"></div>
            <month-select top="20px" left="190px" @change="changemMonth" v-if="showIt"></month-select>
            <calendar-pie v-if="showPie" ref="pie" width="600px" height="552px" top="68px" left="24px"></calendar-pie>
          </div> -->
				</border>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		deleteAction,
		getAction,
		postAction,
		putAction
	} from '@/api/manage'
	import border from '@/components/border/borderType'
	import fileTable from '@/components/border/fileTable'
	import warn from '@/components/border/warn'
	import analysis from '@/views/tenant/ysjhb/dashboard/com/analysis'
	import calendar from '@/components/env-bigData/calendar'
	import calendarPie from '@/components/env-bigData/calendarPie'
	import monthSelect from '@/components/date/bmonthSelect'
	import dial from '@/components/env-bigData/watch'
	import {
		queryWastDateList,
		queryWasteCurveAnalysis,
		queryScreenWarn,
		querWasteReport,
		queryStandardTreeList,
		queryWasteStand,
		standardWasteMonth,
    ajaxGetDictItems 
	} from '@/api/api'
	export default {
		data() {
			return {
				radioStatu: true,
				showRadio: true,
				showDial: false,
				standState: false,
				showToast: false,
				showPie: true,
				stand: [],
				showDetail: false,
				dateList: [],
				siteId: 0,
				analysisType: 11,
				start: '',
				end: '',
				waterWarnList: [],
				defaultValue: 1,
				quantum: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
				colors: ['#ccc'],
				standardList: [],
				showIt: false,
				showAnalysis: false,
				standText: '',
				standLabel: '',
				defaultValues: 0,
				radioIndex: '',
				flowData: '',
				flowRaw: '',
        companyInfo:{},
        dictDataArr:{
          typeArr:[],
          scaleArr:[],
          yesNoStatusArr:[],
          attributeArr:[]
        }
			}
		},
		components: {
			border,
			fileTable,
			analysis,
			warn,
			calendar,
			monthSelect,
			dial,
			calendarPie,
		},
		props: {
			selectId: {
				default: '0',
				type: String
			},
			selectType: {
				default: '0',
				type: String
			},
      siteDetail:{
        default: {},
        type: Object
      }
		},
		watch: {
			selectId(val) {
				this.showRadio = false
				this.$nextTick(() => {
					this.showRadio = true
					this.analysisType = 11
					this.$nextTick(() => {
						// this.getStandard(val)
						this.defaultValues = 1
						this.getFlow(val)
						this.getReport(val)
						this.getDateList(val)
						this.getWarn(this.defaultValues, val, this.selectType)
						// this.getwaterStand(val)
						this.getPolutionData(val)
            // this.getCompanyData()
					})
				})
			},
      siteDetail:{
        handler(newVal, oldVal){
          if(newVal.companyId){
            this.getCompanyData()
          }
        },
        deep: true,
        immediate: true
      }
		},
		created() {
      this.getDataFromDict('company_type').then(res => {
              console.log('res',res.find(item => item.value == this.companyInfo.type))
              this.dictDataArr.typeArr = res
            })
            this.getDataFromDict('company_scale').then(res => {
              this.dictDataArr.scaleArr = res
            })
            this.getDataFromDict('yes_no_status').then(res => {
              this.dictDataArr.yesNoStatusArr = res
            })
            this.getDataFromDict('management_attribute').then(res => {
              this.dictDataArr.attributeArr = res
            })
			// this.getStandard()
		},
		mounted() {
			// setInterval(this.scroll, 1000)


		},
		methods: {  
      handleDictName(dictKey, dictValue){
        if(this.dictDataArr[dictKey]){
          return (this.dictDataArr[dictKey].find(item => item.value == dictValue)?this.dictDataArr[dictKey].find(item => item.value == dictValue).text:'') || ''
        }
        return ''
      },
      getCompanyData(){
        getAction(`/site/company/${this.siteDetail.companyId}` , {}).then(res => {
          if (res.success) {
            this.companyInfo = res.result

            console.log('this.companyInfo',this.companyInfo)
          }
        })
      },
      getDataFromDict(code){
        return new Promise((resolve, reject) => { 
          ajaxGetDictItems(code).then(res => {
            if (res.success) {
              resolve(res.result)
            }
          }).catch(err => {
            reject(err)
          })
        })
      },
			getFlow(scopeId) {
				getAction(`/online/st${this.selectType}/chart`, {
					scopeId,
					type: 1,
					stime: this.getDay(0),
					etime: this.getDay(0),
					dataType: 12
				}).then(res => {
					if (res.success && res.result.records.length > 0 && res.result.records[0].factor && res.result
						.query.factors.length > 0) {

						let code

						res.result.query.factors.forEach((item, index) => {

							if (item.title == '累计流量') {

								code = item.code

								return;

							}

						})
						if(code){
							this.flowData =res.result.records[0].factor[code].hasOwnProperty('value')?res.result.records[0].factor[code].value!=null&&res.result.records[0].factor[code].value!=undefined?res.result.records[0].factor[code].value:'':''
							
							this.flowRaw =res.result.records[0].factor[code].hasOwnProperty('raw')? res.result.records[0].factor[code].raw!=null&&res.result.records[0].factor[code].raw!=undefined?res.result.records[0].factor[code].raw:'':''
						}else{
							this.flowData = ''
							
							this.flowRaw = ''
						}
					} else {

						this.flowData = ''

						this.flowRaw = ''

					}
				})
				// queryWasteCurveAnalysis({
				// 	scopeId,
				// 	type: 1,
				// 	stime: this.getDay(0),
				// 	etime: this.getDay(0),
				// 	dataType: 12
				// }).then(res => {
				// 	if (res.success && res.result.records.length > 0 && res.result.records[0].factor && res.result
				// 		.query.factors.length > 0) {
				// 		let code
				// 		res.result.query.factors.forEach((item, index) => {
				// 			if (item.title == '累计流量') {
				// 				code = item.code
				// 				return;
				// 			}
				// 		})
				// 		this.flowData = res.result.records[0].factor[code].value
				// 		this.flowRaw = res.result.records[0].factor[code].raw
				// 	} else {
				// 		this.flowData = ''
				// 		this.flowRaw = ''
				// 	}
				// })
			},
			changetadios(e) {
				this.defaultValues = e
				if (e == 0) this.radioIndex = ''
				else this.radioIndex = e
				this.getWarn(this.radioIndex, this.selectId, this.selectType)
				// this.getWarn(this.radioIndex,this.selectType)
			},
			ontoGet(value, year) {
				console.log(value, year)
				this.resetSetItem('siteId', this.selectId)
				this.resetSetLocalItem('treeSt', '32')
				// window.localStorage.setItem('treeSt','21')
				this.resetSetItem('siteType', '32')
				setTimeout(() => {
					this.$router.push({
						path: '/online/cn2061',
						query: {
							year,
						},
					})
				}, 500)
				// if (value) this.toastText = value
				// else this.toastText = '暂无数据'
				// this.showToast = true
				// setTimeout(() => {
				// 	this.showToast = false
				// }, 2000)
			},
			ontoSelect() {
				this.showDetail = true
				this.showIt = true
				if (this.showDetail) {
					// this.$refs.pie.initBarChart('2020-11')
				}

			},
			getStand(data) {
				if (data) {
					for (let i = 0; i < this.standardList.length; i++) {
						if (this.standardList[i].data.title == data.title) {
							return i + 1
						}
					}
				} else {
					return 0
				}
			},

			getwaterStand(scopeId) {
				getAction(`/online/st${this.selectType}/standardBySite`, {
					scopeId,
					scope: 1
				}).then((res) => {
					if (res.success && res.result) {
						let color = []
						let title = []
						let a = []
						let colors = ['green', 'red']
						let date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res
							.result)[1]]
						// date.push(Object.keys(res.result['同比标准'])[0])
						// date.push(Object.keys(res.result['实时标准'])[0])
						// date.push(Object.keys(res.result['环比标准'])[0])
						if (res.result[date[0]] != null && res.result[date[0]].upStandard != null) {
							if (res.result[date[0]].upStandard == true) {
								color.push(colors[0])
								title.push('达标')
								a.push(1)
							} else {
								color.push(colors[1])
								title.push('不达标')
								a.push(2)
							}
						} else {
							color.push('')
							title.push('')
							a.push(0)
						}
						if (res.result[date[1]] != null && res.result[date[1]].upStandard != null) {
							if (res.result[date[1]].upStandard == true) {
								color.push(colors[0])
								title.push('达标')
								a.push(1)
							} else {
								color.push(colors[1])
								title.push('不达标')
								a.push(2)
							}
						} else {
							color.push('')
							title.push('')
							a.push(0)
						}
						if (res.result[date[2]] && res.result[date[2]].upStandard != null) {
							if (res.result[date[2]].upStandard == true) {
								color.push(colors[0])
								title.push('达标')
								a.push(1)
							} else {
								color.push(colors[1])
								title.push('不达标')
								a.push(2)
							}
						} else {
							color.push('')
							title.push('')
							a.push(0)
						}
						this.showDial = true
						this.$nextTick(() => {
							this.$refs.dials.initBarChart(title, color, date, a, 2)
						})

						// let arr = []
						// let color = []
						// if(res.result['同比标准']){
						// 	color.push()
						// }
						// color.push()
					} else {
						this.showDial = true
						let date = new Date()
						let year1 = date.getFullYear() - 1 + '-' + (date.getMonth() + 1) + '-' + date.getDate()
						let year2 = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
						let year3 = date.getMonth() != 0 ? (date.getFullYear() + '-' + date.getMonth() + '-' + date
							.getDate()) : ((date.getFullYear() - 1) + '-12' + '-' + date.getDate())
						this.$nextTick(() => {
							this.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1,
								year2, year3
							], [0, 0, 0], 2)
						})
					}
				})
			},
			// 获取国标数据
			getStandard(id) {
				queryStandardTreeList().then((res) => {
					if (res.success) {
						// res.result[0].children[0].children.forEach((item, index) => {
						//   item.data.title = item.data.title.replace('类', '')
						//   item.data.show = true
						//   return item
						// })
						this.colors = ['#ccc']
						let arr = []
						let stand = []
						res.result.forEach((item, index) => {
							if (item.label == '国家标准') {
								if (item.children != null) {
									item.children.forEach((item1, index1) => {
										if (item1.key == 'K1_3') {
											arr = item1.children
											stand = JSON.parse(JSON.stringify(item1.children))
											return
										}
									})
								}
							}
						})
						let colors = []
						let title = []
						arr.forEach((item, index) => {
							// item.data.title = item.data.title.replace('类', '')
							colors.push(item.data.color)
							title.push(item.data.title)
							// return item
						})
						this.title = title
						stand.forEach((item, index) => {
							item.data.title = item.data.title.replace('类', '')
							return item
						})
						this.colors = [...colors, ...this.colors]
						this.standardList = arr
						this.stand = stand
						// this.getReport(id)
					}
				})
			},
			monthChange(value) {
				this.quantum = value
				if (this.siteId) {
					this.getReport(this.siteId)
				}
			},
			changemMonth(value) {

				this.showPie = false
				this.$nextTick(() => {
					this.showPie = true
					if (this.siteId) {
						this.getStandmonth(this.siteId, value)
					}
				})
			},
			// 获取各个月份的饼图数据
			getStandmonth(id, quantum) {
				getAction(`/st${this.selectType}/cn2061/report/standardMonth/`, {
					id,
					quantum,
				}).then((res) => {
					if (res.success) {
						let label = []
						let a = []
						let color = []
						let arr = []
						let data = []
						res.result.standard.forEach((item, index) => {
							label.push(item.title)
						})
						let monthArr = Object.keys(res.result.monthStandard)
						monthArr.forEach((item, index) => {
							// if(res.result.monthStandard[item])
							if (!(JSON.stringify(res.result.monthStandard[item]) == '{}')) {
								// let arr = Object.keys(res.result.monthStandard[item])
								let arrs = []
								let obj = {}
								// for (let j = 0; j < arr.length; j++) {
								for (let i = 0; i < res.result.standard.length; i++) {
									obj.name = res.result.standard[i].title
									obj.color = res.result.standard[i].color

									if (res.result.monthStandard[item][res.result.standard[i].title]) {
										obj.value = res.result.monthStandard[item][res.result.standard[i]
											.title
										].num
										color.push(res.result.standard[i].color)
									} else {
										obj.value = 0
										color.push('')
									}
									data.push(obj)
									obj = {}
									// }
								}
								arr.push(data)
								data = []
								color = []
							} else {
								let obj = {}

								for (let i = 0; i < res.result.standard.length; i++) {
									color.push('')
									obj.name = res.result.standard[i].title
									obj.color = res.result.standard[i].color
									obj.value = 0
									data.push(obj)
									obj = {}
								}
								arr.push(data)
								data = []
							}
						})
						// setTimeout(() => {
						this.$refs.pie.initBarChart(quantum, label, arr)
						// }, 200)
					}
				})
			},
			getDaysInOneMonth(year, month) {
				month = parseInt(month, 10)
				var d = new Date(year, month, 0)
				return d.getDate()
			},
			// 获取水质日历数据
			getReport(scopeId) {
				getAction(`/online/st${this.selectType}/report/`, {
					scopeId,
					scope: 1,
					st: 32,
					type: 3,
					quantum: this.quantum,
				}).then((res) => {
					if (res.success) {
						let a = []
						let num = this.getDaysInOneMonth(this.quantum.split('-')[0], this.quantum.split('-')[1])
						res.result.records.forEach((item, index) => {
							if (index < num) {
								if (item.attrs.targetStandard && item.attrs.upStandard !== null) {
									if (item.attrs.upStandard) a.push(1)
									else a.push(2)
								} else {
									a.push(0)
								}
							}
						})
						this.$refs.calendar.initBarChart(
							this.quantum.split('-')[0],
							this.quantum.split('-')[1],
							a,
							['#ccc', 'green', 'red'],
							['', '达标', '不达标']
						)
					}
				})
			},
			scroll() {
				setTimeout(() => {
					if (this.waterWarnList.length > 5) {
						this.waterWarnList.push(this.waterWarnList[0]) // 将数组的第一个元素添加到数组的
						this.waterWarnList.shift() //删除数组的第一个元素
					}
				}, 500)
				setTimeout(() => {
					if (this.dateList.length > 6) {
						this.dateList.push(this.dateList[0]) // 将数组的第一个元素添加到数组的
						this.dateList.shift() //删除数组的第一个元素
					}
				}, 500)
			},
			//获取预警内容
			getWarn(category, scopeId, st) {
				let params = {
					category,
					scope: 1,
					scopeId,
					warnStatus: 1,
					// current: 1,
					// size: 20,
					// st
				}
				// 污水站点
				queryScreenWarn(params).then((res) => {
					if (res.success && res.result.length > 0) {
						res.result.forEach((item, index) => {
							switch (item.category) {
								case '1':
									item.category_dictText = '数据报警'
									break;
								case '2':
									item.category_dictText = '设备报警'
									break;
								case '4':
									item.category_dictText = '离线预警'
									break;
							}
						})

						this.waterWarnList = res.result
					} else {
						this.waterWarnList = []
					}
				})
			},
			// 获取日期
			getDay(day) {
				let today = new Date()
				var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day
				today.setTime(targetday_milliseconds) //注意，这行是关键代码
				var tYear = today.getFullYear()
				var tMonth = today.getMonth()
				var tDate = today.getDate()
				let hour = today.getHours()
				let minute = today.getMinutes()
				let second = today.getSeconds()
				tMonth = this.doHandleMonth(tMonth + 1)
				tDate = this.doHandleMonth(tDate)
				return tYear + '-' + tMonth + '-' + tDate
				// return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
			},
			doHandleMonth(month) {
				var m = month
				if (month.toString().length == 1) {
					m = '0' + month
				}
				return m
			},
			// 获取水质趋势
			getPolutionData(id, start) {
				if (id) this.siteId = id
				if (!start) start = this.getDay(0)
				getAction(`/online/st${this.selectType}/chart`, {
					scopeId: this.siteId,
					type: 1,
					stime: start,
					etime: this.getDay(0),
					dataType: this.analysisType
				}).then((res) => {
					if (res.success) {
						if (res.result.records.length > 0) {
							let obj = {}
							let popArr = []
							let arr = []
							let time = []
							let labelData = []
							let seriesData = {}

							res.result.query.factors.forEach((ele) => {
								labelData.push(ele.title)
								res.result.records.forEach((element) => {
									if (element.factor[ele.code]) {
										obj.name = element.dateStr
										obj.value = element.factor[ele.code].value != null ?
											element.factor[ele.code].value : 0
										arr.push(obj)
										obj = {}
									}
								})
								seriesData.data = arr
								seriesData.title = ele.title
								popArr.push(seriesData)
								seriesData = {}
								arr = []
							})
							res.result.records.forEach((data) => {
								time.push(data.dataTime)
							})
							// this.pollutionData = popArr
							// this.time = time
							// this.labelData = labelData
							this.showAnalysis = false
							this.$nextTick(() => {
								this.showAnalysis = true
								setTimeout(() => {
									this.$refs.pollution.initBarChart(popArr, time, labelData)
								}, 100)
							})
						} else {
							this.showAnalysis = false
							this.$nextTick(() => {
								this.showAnalysis = true
								setTimeout(() => {
									this.$refs.pollution.initBarChart([], [], [])
								}, 100)
							})
						}
					}
				})
			},
			// 获取日报数据
			getDateList(scopeId) {
				queryWastDateList({
					scopeId,
					type: 1,
					st: 32,
					scope: 1
				}).then((res) => {
					if (res.success && res.result.records.length > 0) {
						let state
						let arr = []
						let obj = {}
						res.result.query.factors.forEach((item, index) => {
							if (res.result.records[0].factor[item.code]) {
								obj.value = res.result.records[0].factor[item.code].value != null && res
									.result.records[0].factor[item.code].value != undefined ? res.result
									.records[0].factor[item.code].value : ''
								// item.standTitle = res.result.records[0].factor[item.code].standard.title
								// item.standColor = res.result.records[0].factor[item.code].standard.color
								//         if (res.result.records[0].factor[item.code].status == 1) state='达标'
								// else if(res.result.records[0].factor[item.code].status == null) state = ''
								// else state = '不达标'
								if (res.result.records[0].factor[item.code].status == 1) obj.standColor =
									'green'
								else if (res.result.records[0].factor[item.code].status == null || res
									.result.records[0].factor[item.code].status == undefined) obj
									.standColor = ''
								else obj.standColor = 'red'
								obj.state = state
								obj.title = item.title
								obj.unitName = item.unitName
								obj.render = this.renderCol(item.code, '', res.result.records[0])
								obj.flagState = ''
								obj.flagCode = ''
								if(res.result.records[0].factor[item.code].hasOwnProperty('flag')){
									obj.flagState = res.result.records[0].factor[item.code]['flag'].message!=undefined&&res.result.records[0].factor[item.code]['flag'].message!=null?res.result.records[0].factor[item.code]['flag'].message:''
									obj.flagCode = res.result.records[0].factor[item.code]['flag'].code!=undefined&&res.result.records[0].factor[item.code]['flag'].code!=null?res.result.records[0].factor[item.code]['flag'].code:''
								}
								state = ''
								arr.push(obj)
								obj = {}
								return item
							}
						})
						this.standState = res.result.records[0].attrs.upStandard
						this.standLabel = res.result.records[0].attrs.upStandard ? '达标' : '不达标'
						// this.standText = res.result.records[0].currentStandard.title

						this.dateList = arr
					} else {
						res.result.query.factors.forEach((item, index) => {
							item.value = ''
							item.standColor = ''
							item.flagState = ''
							item.render = ''
							item.flagCode = ''
							return item
						})
						this.standState = false
						this.standLabel = ''
						this.dateList = res.result.query.factors
					}
				})
			},
			// 渲染列
			renderCol(code, text, record) {
				let data = record.factor[code] || {
					value: '',
				}
				if (data.status == '2') {
					return (
						"<span  style='color:green;padding-left:15px' class='redText' title='原始数据：  " +
						(data.raw != null ? data.raw : '一') +
						"'>" +
						(data.value != null ? data.value : '一') +
						"<div class='iconfont icon-xiangxiajiantou' style='float:right;color:green' ></div></span>"
					)
				} else if (data.status == '3') {
					return (
						"<span style='color:red;padding-left:15px' title='原始数据：" +
						(data.raw != null ? data.raw : '一') +
						"'>" +
						(data.value != null ? data.value : '一') +
						"<div class='iconfont icon-iconset0414' style='float:right;color:red' ></div></span>"
					)
				} else {
					return "<span title='原始数据：" + (data.raw != null ? data.raw : '一') + "'>" + (data.value != null ? data
						.value : '一') + '</span>'
				}
			},
			changeRadio(e) {
				let time
				switch (e.target.value) {
					case 1:
						this.analysisType = 11
						this.getPolutionData('', this.getDay(0))
						break
					case 2:
						this.analysisType = 12
						this.getPolutionData('', this.getDay(7))
						break
					case 3:
						this.analysisType = 12
						this.getPolutionData('', this.getDay(30))
						break
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
	.realtime {
		width: 99.5%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.flow-txt {
			width: 100%;
			color: #fff;
			font-size: 22px;
			margin-top: 25px;
			text-align: center;

			span {
				color: #0ff;
				font-weight: bold;
				font-size: 35px;
				margin-right: 5px;
				font-family: 'UnidreamLED';
				cursor: pointer;
			}
		}
	}
  
  .company-info{
    display: flex;
    flex-direction: column;
    color: #fff;
    margin-top: 20px;
    margin-left: 15px;
    margin-right: 15px;
    .company-name{
      font-size: 14px;
      line-height: 1.6;
      margin-bottom: 8px;
      padding: 6px 10px;
      border-radius: 4px;
      background-color: rgba(255, 255, 255, 0.05);
      transition: all 0.3s ease;
      
      &:hover{
        background-color: rgba(255, 255, 255, 0.1);
        transform: translateX(5px);
      }
      
      &:last-child{
        margin-bottom: 0;
      }
    }
  }

	.radios .ant-radio-group {
		// position: absolute;
		// top: 25px;
		// left: 167px;
	}

	.ant-radio-wrapper {
		color: #fff !important;
	}

	.border-detail {
		color: #fff;
		font-size: 35px;
		position: absolute;
		left: 20px;
		top: 10px;
	}

	.icon-bingtu {
		user-select: none;
		cursor: pointer;
	}

	.icon-rili {
		user-select: none;
		cursor: pointer;
	}

	.popout {
		position: fixed;
		left: 38%;
		top: 23%;
		background-color: #0a0b58;
		z-index: 17;
		width: 650px;
		height: 630px;
	}

	.icon-dacha {
		font-size: 30px;
		color: #fff;
		position: absolute;
		right: 0;
		cursor: pointer;
		user-select: none;
	}

	.realtime-bg {
		left: 34%;
		position: absolute;
		top: 35%;
		font-size: 35px;
		color: green;
		width: 150px;
		height: 150px;
		border-radius: 50%;
		border: 3px solid green;
		text-align: center;
		line-height: 150px;
		transform: rotate(-14deg);
		display: flex;
		flex-direction: column;
		line-height: 40px;
		align-items: center;
		justify-content: center;
	}

	.realtime-bg-red {
		left: 34%;
		position: absolute;
		top: 35%;
		font-size: 35px;
		color: red;
		width: 150px;
		height: 150px;
		border-radius: 50%;
		border: 3px solid red;
		text-align: center;
		line-height: 150px;
		transform: rotate(-14deg);
		display: flex;
		flex-direction: column;
		line-height: 40px;
		align-items: center;
		justify-content: center;
	}

	.border-right {
		position: absolute;
		right: 10px;
		bottom: 0;
		max-height: 100%;
		// width: 50px;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		// background-color: #235189;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px 0;
		z-index: 16;
	}

	.map-tag-cir {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		font-size: 10px;
		color: #333;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
		margin-top: 7px;
	}

	.toast {
		position: absolute;
		z-index: 2000;
		left: 50%;
		top: 45%;
		transition: all 0.5s;
		-webkit-transform: translateX(-50%) translateY(-50%);
		-moz-transform: translateX(-50%) translateY(-50%);
		-ms-transform: translateX(-50%) translateY(-50%);
		-o-transform: translateX(-50%) translateY(-50%);
		transform: translateX(-50%) translateY(-50%);
		text-align: center;
		border-radius: 5px;
		color: #fff;
		background: rgba(17, 17, 17, 0.7);
		height: 45px;
		line-height: 45px;
		padding: 0 15px;
		// max-width: 150px;
	}
</style>
